import React, { Component } from 'react';
import Dashboard from './Dashboard';
import SummarySheet from './Summary/SummarySheet';
import { DatasetDetailsAsync, GetDataStoredInDatasetAsync, FieldArrayAsync, DetailFieldArrayAsync} from './fetchData';
import ListTable from './ListTableView'
import MatrixView from './MatrixView'
import BrowserView from './BrowserView'
import {
  BrowserRouter,
  Route,
} from 'react-router-dom'
import { Loading } from './Loading';
import Toolbars from './Toolbars';
import {PageView, initGA} from './Tracking';

export default class Dataset extends Component {

  constructor(props){
	super(props)
	let ProductName = "VP"
	let datasetID = 1
	let FullProductPath = "VPDashboard"
	let appURL = ""
	if (props.match !== undefined){
		ProductName = props.match.params.ProductName;
		datasetID = props.match.params.id;
		FullProductPath = props.match.params.FullProductPath;
		appURL = props.match.params.appURL;
	}else {
		ProductName = props.ProductName;
		datasetID = props.datasetID;
		FullProductPath = props.FullProductPath;
		appURL = props.appURL;
	}
	this.state = {
		ViewObject: {},
		datasetDetails: [],
		loading: true,
		datasetID: datasetID,
		ProductName: ProductName,
		FullProductPath: FullProductPath,
		appURL: appURL,
		WebsiteURL: "https://www.thevantagepoint.com/",
		DefaultYouTubeURL: "https://youtu.be/ScKw2NF27OU",
		YouTubeURL: "https://youtu.be/l7v0b6TZHdw",
		TitleViewField: "",
		FieldArray: [],
		DetailFields: [],
		selectedSheetID: 'Home',
		titleWindowData: {
		  showRecordView: false,
		  RecordNumbers: []
		},
		viewType: "",
	}
	
}
fetchData(appURL, datasetID){
	DatasetDetailsAsync(appURL, datasetID)
	.then((data) => {
		console.log(data)
		FieldArrayAsync(appURL, datasetID)
		.then((fields) => {
			DetailFieldArrayAsync(appURL, datasetID)
			.then((DetailFields) => {
				GetDataStoredInDatasetAsync(appURL, datasetID, "TitleViewField", "Text")
				.then((titleField) => {
					GetDataStoredInDatasetAsync(appURL, datasetID, "FullSummary")
					.then((summary) => {
						let fullSummary = "";
						if (summary !== "" && summary !== "Unable to GetDataStoredInDataset") {
							fullSummary = summary
						}
						this.setState({
							datasetDetails: data,
							FieldArray: fields,
							DetailFields: DetailFields,
							FullSummary: fullSummary,
							TitleViewField: titleField,
							loading: false
						})
					})
				})
			})
		})
	})
}

componentDidMount(){
	this.fetchData(this.state.appURL, this.state.datasetID)
	initGA('UA-5409011-1')
	PageView();
}
resetApp = () => {
	this.props.callbackFromParent()
}
  render() {
	const {
		datasetID,
		selectedSheetID,
		loading,
		ProductName,
		FullProductPath,
		datasetDetails,
		FieldArray,
		DetailFields,
		TitleViewField,
		FullSummary,
		appURL
	} = this.state;
	return (
	  <div>
	  {loading === true
		  ? <Loading />
		  :
		  <div className="Dataset">
		  <BrowserRouter basename={`/${FullProductPath}`}>
			<div className="MainWindow">
				<Toolbars callbackFromParent={this.resetApp} appURL={appURL} ProductName={ProductName} FullProductPath={FullProductPath} datasetID={datasetID} selectedSheetID={selectedSheetID} datasetDetails={datasetDetails} FieldArray={FieldArray} DetailFields={DetailFields} TitleViewField={TitleViewField}></Toolbars>
			  <Route exact path={'/'} render={props => <Dashboard appURL={appURL} FullProductPath={FullProductPath} ProductName={ProductName} datasetID={datasetID} datasetDetails={datasetDetails} FieldArray={FieldArray} DetailFields={DetailFields} TitleViewField={TitleViewField} FullSummary={FullSummary}/>}/>
			  <Route exact path={'/:ProductName/'} render={props => <Dashboard appURL={appURL} FullProductPath={FullProductPath} datasetID={datasetID} datasetDetails={datasetDetails} FieldArray={FieldArray} DetailFields={DetailFields} TitleViewField={TitleViewField} FullSummary={FullSummary}/>}/>
			  <Route exact path={'/:ProductName/:datasetID'} render={props => <Dashboard appURL={appURL} FullProductPath={FullProductPath} ProductName={ProductName} datasetID={datasetID} datasetDetails={datasetDetails} DetailFields={DetailFields} FieldArray={FieldArray} TitleViewField={TitleViewField} FullSummary={FullSummary}/>}/>
			  <Route exact path={'/:ProductName/Dashboard/:datasetID'} render={props => <Dashboard appURL={appURL} FullProductPath={FullProductPath} ProductName={ProductName} datasetID={datasetID} datasetDetails={datasetDetails} FieldArray={FieldArray} DetailFields={DetailFields} TitleViewField={TitleViewField} FullSummary={FullSummary}/>} />
			  <Route exact path={'/:ProductName/summary/:datasetID'} render={SummarySheet}/>
			  <Route exact path={'/:ProductName/list/:datasetID/:id'} component={ListTable}/>
			  <Route exact path={'/:ProductName/matrix/:datasetID/:id'} component={MatrixView}/>
			  <Route exact path={'/:ProductName/browser/:datasetID/:id'} component={BrowserView}/>
			</div>
			<div className="OpenYoutubeIcon" title="Watch a Demo of the Dashboard" onClick={() => window.open(this.state.YouTubeURL, '_blank')}></div>
			<div className="poweredByVPButton" title="Powered By VantagePoint" onClick={() => window.open(this.state.WebsiteURL, '_blank')}></div>
			<div className="copyrightText" title={`© 2001 - ${new Date().getFullYear()} Search Technology, Inc.`}>© 2001 - {new Date().getFullYear()} Search Technology, Inc.</div>
		  </BrowserRouter>
		  </div>
		}
	  </div>
	);
  }
}
